import { AxiosInstance } from 'axios'
import { createOptimizedAPI } from '../utils'
import { IHomepageContribution } from '../../../types/contributions.types'

export function homepageContributionsApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/contributions'

  const methods = {
    getContributions() {
      return api.get<{ items: IHomepageContribution[] }>(baseUrl)
    }
  }
  return createOptimizedAPI(methods)
}
